import { Deserializable } from '../../../lib/models/deserializable';

export class BrandConsent implements Deserializable {
  public BrandConsentID: number;
  public ContactByTelephone?: boolean;
  public ContactByEmail?: boolean;
  public ContactBySms?: boolean;
  public ContactByPost?: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
